import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6 col-md-3" }
const _hoisted_5 = { class: "col-6 col-md-3" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "col-6 col-md-3" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-6 col-md-3" }
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = { class: "col-md-12 table-responsive" }
const _hoisted_12 = { class: "table align-middle mb-0 table-hover" }
const _hoisted_13 = { class: "nowrap-celular" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-center text-nowrap" }
const _hoisted_16 = { class: "card-footer" }
const _hoisted_17 = { class: "row mt-2" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "col-md-2" }

import { defineComponent, onMounted, reactive } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as planoService from "@/services/planosService";
  import {f2dec} from "@/utils/funcoes";

  //componentes
  import Paginador from "@/components/Paginador/Index.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  var controle = reactive({
    filtros: {
      statusId: null,
      tipoId: null,
      paginaAtual: 1,
      tamanhoPagina: 20
    } as unknown as planoService.Filtros,
    itens: [] as planoService.Plano[],

    tipos: ['- Todos -','Particular','Empresarial'] ,
    listaStatus:[ 
      {valor: null, descricao:"- Todos -"},
      {valor: true, descricao:"Ativos"},       
      {valor: false, descricao:"Inativos"},
    ],

    status: "",
    erro: "",

    ordenacao: {
      coluna: '',
      asc: true
    },
  })

  onMounted(async ()=>{
    
    pesquisar();
  })

  async function pesquisar() {

    planoService.obter(controle.filtros)
    .then(r=> {
      controle.itens = r;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

  function ordenarPor(coluna: string) {
    if (controle.ordenacao.coluna === coluna) {
      controle.ordenacao.asc = !controle.ordenacao.asc;
    } else {
      controle.ordenacao.coluna = coluna;
      controle.ordenacao.asc = true;
    }
    controle.itens.sort((a, b) => {
      let valA = (a as Record<string, any>)[coluna];
      let valB = (b as Record<string, any>)[coluna];
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return controle.ordenacao.asc ? -1 : 1;
      if (valA > valB) return controle.ordenacao.asc ? 1 : -1;
      return 0;
    });
  }

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, { PageTitle: "Planos" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("label", null, [
              _createElementVNode("i", { class: "flaticon-search" }),
              _createTextVNode(" Pesquisar")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              placeholder: "Descrição...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).filtros.nome) = $event)),
              onKeyup: pesquisar
            }, null, 544), [
              [_vModelText, _unref(controle).filtros.nome]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[10] || (_cache[10] = _createElementVNode("label", null, "Tipo", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).filtros.tipo) = $event)),
              onChange: pesquisar
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("option", { value: null }, "- Todos -", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).tipos, (item, idx) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item,
                  key: idx
                }, _toDisplayString(item), 9, _hoisted_6))
              }), 128))
            ], 544), [
              [_vModelSelect, _unref(controle).filtros.tipo]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[11] || (_cache[11] = _createElementVNode("label", null, "Status", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).filtros.ativo) = $event)),
              onChange: pesquisar
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).listaStatus, (item, idx) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item.valor,
                  key: idx
                }, _toDisplayString(item.descricao), 9, _hoisted_8))
              }), 128))
            ], 544), [
              [_vModelSelect, _unref(controle).filtros.ativo]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-primary btn-sm mt-4 float-end",
              to: '/planos/cadastro'
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createElementVNode("i", { class: "flaticon-plus" }, null, -1),
                _createTextVNode(" Adicionar", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("table", _hoisted_12, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (ordenarPor('usuarioId'))),
                    class: "th-sortable"
                  }, "Id"),
                  _createElementVNode("th", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (ordenarPor('nomeCompleto'))),
                    class: "th-sortable"
                  }, "Nome"),
                  _createElementVNode("th", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (ordenarPor('tipoId'))),
                    class: "th-sortable"
                  }, "Tipo"),
                  _createElementVNode("th", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (ordenarPor('email'))),
                    class: "th-sortable"
                  }, "Valor"),
                  _createElementVNode("th", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (ordenarPor('ativo'))),
                    class: "th-sortable"
                  }, "Status"),
                  _cache[13] || (_cache[13] = _createElementVNode("th", null, "Opções", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, idx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: idx,
                    class: "align-middle"
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.planoId), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(item.nome), 1),
                    _createElementVNode("td", null, _toDisplayString(item.tipo), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(f2dec)(item.valor)), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge rounded-pill", item.ativo ? 'badge-soft-success' : 'badge-soft-danger'])
                      }, _toDisplayString(item.ativo ? 'Ativo' : 'Inativo'), 3)
                    ]),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_RouterLink, {
                          class: "text-primary",
                          to: '/planos/cadastro/' + item.planoId
                        }, {
                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createElementVNode("i", { class: "flaticon-pen fs-5" }, null, -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"]),
                        _cache[15] || (_cache[15] = _createElementVNode("a", {
                          class: "text-danger",
                          href: "javascript:void(0);"
                        }, [
                          _createElementVNode("i", { class: "flaticon-delete fs-5 ms-2" })
                        ], -1))
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(controle).itens.length) + " Registros ", 1),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(Paginador, {
              class: "float-end",
              paginaAtual: _unref(controle).filtros.paginaAtual,
              tamanhoPagina: _unref(controle).filtros.tamanhoPagina,
              totalItens: _unref(controle).itens.length,
              onPaginaMudou: pesquisar
            }, null, 8, ["paginaAtual", "tamanhoPagina", "totalItens"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-secondary btn-sm float-end",
              to: '/'
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createElementVNode("i", { class: "flaticon-close" }, null, -1),
                _createTextVNode(" Fechar", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 64))
}
}

})